export enum LicenceCountries {
    SPAIN = 'spain',
    WALES = 'wales',
    SCOTLAND = 'scotland',
    IRELAND = 'ireland',
    UK = 'uk',
}
